import { Card } from '@ipfabric/ui-components/Card/Card';
import { FormTextField } from '@ipfabric/ui-components/FormTextField/FormTextField';
import { Icon } from '@ipfabric/ui-components/Icon/Icon';
import { type FC, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { fullConfiguration, getLeafNodes } from './fullConfiguration.const';
import type { ExportForm } from './importExportConfiguration.types';

interface Props {
  values: Set<string>;
  onChange: (item: Set<string>) => void;
}

export const ExportSidePanelContent: FC<Props> = (props) => {
  const formMethods = useFormContext<ExportForm>();

  const exportEverythingToFile = useWatch({
    control: formMethods.control,
    name: 'exportEverythingToFile',
  });

  useEffect(() => {
    if (exportEverythingToFile) {
      props.onChange(new Set(getLeafNodes(fullConfiguration)));
    } else {
      props.onChange(new Set());
    }
  }, [exportEverythingToFile, props.onChange]);

  return (
    <form>
      <Card>
        <div className='flex flex-col gap items-start bg-default rounded-lg p'>
          <div className='flex flex-col gap-sm'>
            <FormTextField
              control={formMethods.control}
              name='passphrase'
              type='password'
              label='Passphrase for encryption'
              description='Exports include configuration data such as passwords and device credentials that require encryption'
              rules={{
                required: 'This field is required',
                minLength: {
                  value: 8,
                  message: 'Passphrase must have at least 8 characters',
                },
              }}
              startAdornment={
                <Icon glyph='fa-key' iconStyle='regular' size='sm' />
              }
            />
            <FormTextField
              control={formMethods.control}
              name='passphraseRepeat'
              type='password'
              label='Repeat passphrase'
              rules={{
                required: 'This field is required',
                validate: (value) =>
                  value === formMethods.getValues('passphrase') ||
                  'Passphrases do not match',
              }}
              startAdornment={
                <Icon glyph='fa-key' iconStyle='regular' size='sm' />
              }
            />
          </div>
        </div>
      </Card>
    </form>
  );
};
